// "View as user" — admin-only client store.
//
// Stores the impersonation target in sessionStorage so it doesn't survive
// closing the tab (deliberate: shared-laptop safety). The store is a tiny
// pub/sub so non-React code (apiFetch) can read the current value
// synchronously while React components subscribe via useImpersonation.

const STORAGE_KEY = 'impersonate-email';

type Listener = (email: string | null) => void;
const listeners = new Set<Listener>();

function read(): string | null {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    return v && v.trim() ? v.trim() : null;
  } catch {
    // Some browsers throw on sessionStorage in private mode — fail closed.
    return null;
  }
}

export function getImpersonationEmail(): string | null {
  return read();
}

export function setImpersonationEmail(email: string | null): void {
  try {
    if (email && email.trim()) {
      sessionStorage.setItem(STORAGE_KEY, email.trim());
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // ignore — banner will read whatever ends up in storage
  }
  const next = read();
  for (const l of listeners) l(next);
}

export function subscribeImpersonation(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
